import { put, takeLatest } from "redux-saga/effects";
import { requestApi } from "../../../../js/utils/requests";
import * as Actions from "../actions";
import * as Constants from "../constants";
import * as Services from "../services";

export function* createLiveSessionRequest(config) {
  const { courseId, data } = config;
  try {
    const response = yield requestApi(Services.createLiveSession(courseId, data));
    if (response && response.status >= 200 && response.status < 300) {
      const { data: responseData } = response;
      yield put(Actions.createLiveSessionSuccess(responseData));
    } else {
      throw response;
    }
  } catch (error) {
    yield put(Actions.createLiveSessionError(error));
  }
}

export function* createLiveSessionWatcher() {
  yield takeLatest(Constants.CREATE_LIVE_SESSION, createLiveSessionRequest);
}

export function* setLiveSessionStateRequest(config) {
  const { liveSessionId, event } = config;
  try {
    const response = yield requestApi(Services.setLiveSessionState(liveSessionId, event));
    if (response?.status >= 200 && response?.status < 300) {
      const { data } = response;
      yield put(Actions.setLiveSessionStateSuccess(data, event));
    } else {
      throw response;
    }
  } catch (error) {
    yield put(Actions.setLiveSessionStateError(error, event));
  }
}

export function* setLiveSessionStateWatcher() {
  yield takeLatest(Constants.SET_LIVE_SESSION_STATE, setLiveSessionStateRequest);
}
